// extracted by css-extract-rspack-plugin
export default {"Icon":"n3yhmZoUvfwWedge","Option":"i283UtsYBQ9weOBa"};